import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getManagementTeamList as getManagementTeamListApi,
	getManagementTeam as getManagementTeamApi,
	addNewManagementTeam as addNewManagementTeamApi,
	updateManagementTeam as updateManagementTeamApi,
	deleteManagementTeam as deleteManagementTeamApi,
} from '../../helpers/establishment/backend_helper';

export const getManagementTeamList = createAsyncThunk('management_teams/getManagementTeamList', async () => {
	try {
		const response = getManagementTeamListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getManagementTeam = createAsyncThunk('management_teams/getManagementTeam', async management_team_id => {
	try {
		const response = getManagementTeamApi(management_team_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewManagementTeam = createAsyncThunk('management_teams/addNewManagementTeam', async management_team => {
	try {
		const response = addNewManagementTeamApi(management_team);
		toast.success('Integrante agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar integrante.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateManagementTeam = createAsyncThunk('management_teams/updateManagementTeam', async (management_team) => {
		try {
			const response = updateManagementTeamApi(management_team);
			toast.success('Integrante actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar integrante.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteManagementTeam = createAsyncThunk('management_teams/deleteManagementTeam', async management_team => {
	try {
		const response = await deleteManagementTeamApi(management_team);
		toast.success('Integrante eliminado exitosamente.', { autoClose: 3000 });
		return { management_team, ...response };
	} catch (error) {
		toast.error('Error al eliminar integrante.', { autoClose: 3000 });
		throw new Error(error);
	}
});
